import { PaymentStatus } from '@/Enums';

const isOrderPaid = (paymentStatus: PaymentStatus) =>
  paymentStatus === PaymentStatus.OverPaid || paymentStatus === PaymentStatus.Paid;

export const paymentStatusUtils = {
  isOrderPaid,
};
